// Configuration de THOR Diagnostique.
// L'URL du core est injectable au build (VITE_CORE_URL) ou modifiable ici.
// Vide → l'app fonctionne 100% en local (offline), la sync est un no-op.

export const CORE_URL: string =
  (import.meta.env.VITE_CORE_URL as string | undefined)?.replace(/\/$/, "") ??
  "https://core.thor-technologie.com";

export const CORE_ENABLED = CORE_URL.length > 0;

// Produit déclaré au core lors de l'enrôlement. L'enum Produit du core prévoit
// déjà "board_doctor" — c'est l'identité réseau de ce standalone.
export const PRODUIT = "board_doctor";

// Tier commercial du poste (segmentation funnel). Surcharge via VITE_CORE_TIER.
export const TIER: string = (import.meta.env.VITE_CORE_TIER as string | undefined) ?? "diag";

// Fenêtre de tolérance horloge côté core = 300 s : on signe à l'epoch courant.
// Sync automatique en arrière-plan toutes les N minutes quand l'app est ouverte.
export const SYNC_INTERVAL_MS = 15 * 60 * 1000;

// Domaine par défaut de ce produit (carte-mère).
export const DEFAULT_DOMAINE = "board" as const;
